<template>
  <validation-provider
    ref="provider"
    v-slot="{ errors }"
    :rules="rules"
  >
    <input-number
      v-model.number="model"
      :label="label"
      :placeholder="placeholder"
      :input-class="[inputClass, {'border-red-500': errors.length}]"
      :disabled="disabled"
      v-bind="$attrs"
    />
    <p
      v-if="errors.length"
      class="text-xs text-red-500"
      v-text="errors[0]"
    />
  </validation-provider>
</template>

<script>
import InputNumber from '@/components/form/number'

export default {
  components: {
    InputNumber
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputClass: {
      type: [Object, Array, String],
      default: ''
    },
    rules: {
      type: String,
      default: null
    },
    disabled: Boolean
  },
  data: () => ({
    model: 0
  }),
  watch: {
    model (value) {
      this.$emit('input', value)
    },
    value (value) {
      this.model = value
    }
  },
  beforeMount () {
    this.model = this.value
  },
  methods: {
    validate () {
      return this.$refs.provider.validate()
    },
    setErrors (errors) {
      this.$refs.provider.setErrors(errors)
    }
  }
}
</script>
